<template>
  <div
    :id="`ss-sw-${slug}`"
    class="ss-slot"
    :class="{ 'is-has': value, 'is-changed': isChanged, 'is-flash': flashing }"
  >
    <div class="ss-slot__pv">
      <img v-if="value && !broken" :src="ctl.imageUrl(value)" :alt="title" loading="lazy" @error="broken = true" />
      <span v-else-if="value" class="ss-slot__e"><v-icon size="26">mdi-image-broken-variant</v-icon></span>
      <span v-else class="ss-slot__e">
        <v-icon size="26">mdi-image-outline</v-icon>
        <em>{{ $t("settings_shell.appearance.no_image") }}</em>
      </span>
    </div>
    <div class="ss-slot__m">
      <b>{{ title }}</b>
      <span>{{ hint }}</span>
    </div>
    <div class="ss-slot__a">
      <button type="button" class="ui-btn ui-btn--sm" @click="ctl.openPicker(path)">
        <v-icon size="15">{{ value ? "mdi-swap-horizontal" : "mdi-plus" }}</v-icon>
        {{ value ? $t("settings_shell.appearance.replace") : $t("settings_shell.appearance.add") }}
      </button>
      <button
        v-if="value"
        type="button"
        class="ui-btn ui-btn--sm ui-btn--ghost"
        :aria-label="$t('settings_shell.appearance.remove_named', { name: title })"
        :title="$t('remove_image')"
        @click="ctl.askRemoveImage(path)"
      >
        <v-icon size="15">mdi-delete-outline</v-icon>
      </button>
    </div>
    <span v-if="value" class="ss-slot__f">{{ value }}</span>
    <slot></slot>
  </div>
</template>

<script>
import hasSettingsField from "./hasSettingsField";

/** Mjesto za sliku: pregled, izbor iz galerije, uklanjanje; ispod može doći polje sa adresom (link banera). */
export default {
  name: "SetImageSlot",
  mixins: [hasSettingsField],
  props: {
    title: { type: String, required: true },
    hint: { type: String, default: "" },
  },
  data: () => ({ broken: false }),
  watch: {
    value() {
      this.broken = false;
    },
  },
};
</script>
